module.exports = __webpack_public_path__ + "img/carshina21_26.6a0335ad.jpg";